import { Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
  focus,
  icon,
  resourcesItem,
  text,
  wrappedIcon,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { isExternalLink } from 'utils/isExternalLink';

export const ResourcesItem = ({ data, ...props }) => {
  const filePrefix =
    process.env.EDITORA_IMG_URL || process.env.NEXT_PUBLIC_EDITORA_IMG_URL;

  const ctaSlug =
    data?.fields?.url ||
    data?.url ||
    data?.file ||
    filePrefix + (data?.fields?.file || data?.file) ||
    '#';

  const isExternal = isExternalLink(ctaSlug);

  return (
    <div className={resourcesItem().root} {...props}>
      <div className={resourcesItem().contentWrapper}>
        <p
          className={cx(
            text({ size: '2', weight: 'semiBold' }),
            resourcesItem().title,
          )}
        >
          <Link
            href={ctaSlug}
            className={cx(resourcesItem().link, focus())}
            {...((data?.fields?.file || data?.file) && {
              download: data?.fields?.title || data?.title,
              target: '_blank',
              rel: 'noopener noreferrer',
            })}
            {...(isExternal && {
              target: '_blank',
              rel: 'noopener noreferrer',
            })}
          >
            {data?.fields?.title ||
              data?.title ||
              data?.fields?.file ||
              data?.fields?.url}
          </Link>
        </p>

        {data?.fields?.description !== null ||
          (data?.description !== null && (
            <span
              className={cx(
                text({ size: '4', weight: 'medium' }),
                resourcesItem().text,
              )}
              dangerouslySetInnerHTML={{
                __html: data?.fields?.description || data?.description,
              }}
            />
          ))}
      </div>

      <div className={wrappedIcon()}>
        <Icon
          name={
            (data?.fields?.file ? 'download' : 'link') ||
            data.icon_resource ||
            'download'
          }
          classNames={icon({ size: 'm' })}
          aria-hidden='true'
        />
      </div>
    </div>
  );
};
